
import { mapState } from 'vuex'

export default {
  props: {
    collectionHandle: String
  },
  computed: {
    ...mapState({
      allCollections: state => state.collections.all
    }),
    collection () {
      return this.allCollections.find(collection => collection.handle === this.collectionHandle)
    }
  },
  mounted () {
    if (!this.collection) {
      const urlParams = new URLSearchParams(window.location.search);
      const pageNumber = urlParams.get('page');

      this.$store.dispatch('collections/addCollection', {
        handle: this.collectionHandle,
        page: pageNumber,
      });
    }
  }
}
